import { motion } from 'framer-motion';
import { useSearchParams } from 'react-router';
import { StepAccount } from '@/components/commercial/accounts/create/step-account';
import { StepAddresses } from '@/components/commercial/accounts/create/step-addresses';
import { StepContacts } from '@/components/commercial/accounts/create/step-contacts';
import { StepNavigation } from '@/components/commercial/accounts/create/step-navigation';
import { CreateAccountFlowProvider, useCreateAccountFlow } from '@/context/create-account-flow';
import { useAccountStepProgress } from '@/hooks/use-account-step-progress';

function AccountCreateContent() {
  const [searchParams] = useSearchParams();
  const currentStep = searchParams.get('step') || 'account';

  const { account, addresses, contacts } = useCreateAccountFlow();

  // Generate steps using the hook
  const steps = useAccountStepProgress({
    accountId: account?.id || '',
    addresses,
    contacts,
  });

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Nova Conta</h1>
          <p className="text-muted-foreground">
            Preencha os dados abaixo para criar uma nova conta
          </p>
        </div>
      </div>

      {/* Step Navigation */}
      <div className="mb-6">
        <StepNavigation steps={steps} />
      </div>

      {/* Step Content */}
      <div className="w-full max-w-[1400px] mx-auto">
        {currentStep === 'account' && <StepAccount />}
        {currentStep === 'addresses' && <StepAddresses />}
        {currentStep === 'contacts' && <StepContacts />}
      </div>
    </motion.div>
  );
}

export function AccountCreatePage() {
  return (
    <CreateAccountFlowProvider resetOnMount>
      <AccountCreateContent />
    </CreateAccountFlowProvider>
  );
}
